import React, { useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { clienteDataParcial } from '../../../../../store/forms/forms.actions';

// Hooks
import GetIncomeDeclarationClientFile from '../../../../../hooks/GetIncomeDeclarationClientFile';

// Components

import FileInput from '../../../../UI/FormInput/FileInput';
import Button from '../../../../UI/Button/Button';
import DownloadDocumentButton from '../../../../UI/DownloadDocumentButton/DownloadDocumentButton';
import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import Loader from '../../../../UI/Loader/Loader';
import { ACCOUNT_PRODUCT_NAMES } from '../../../../../config/constants';

// Utilities

export default function ClientConstancyFiles({ formik, formStep, setFormStep }) {
    const { getIncomeDeclarationFileIsLoading, getIncomeDeclarationFileError, incomeDeclarationFile, handleGetIncomeDeclarationFile } = GetIncomeDeclarationClientFile();
    const consultClientPartialData = useSelector((state) => state.forms.consultClientPartialData);
    const incomeDeclarationPDF = useSelector((state) => state.clients.incomeDeclarationPDF);

    const shouldGenerateIncomeDeclaration = ['5', '6'].includes(formik.values?.cliente?.tipoCliente);

    const isLoading = shouldGenerateIncomeDeclaration && (consultClientPartialData.isLoading || getIncomeDeclarationFileIsLoading);
    const error = shouldGenerateIncomeDeclaration && (consultClientPartialData.error || getIncomeDeclarationFileError);

    const dispatch = useDispatch();

    useEffect(() => {
        if (formik?.values) {
            const hasLevelOneAccount = formik.values?.selectedProducts?.some(
                item => item.label === ACCOUNT_PRODUCT_NAMES.currentLevelOneAccount
            );

            formik.setFieldValue('recaudos.tipoDocumento', formik?.values?.cliente?.tipoDocumento);
            formik.setFieldValue('recaudos.hasBankReference', formik?.values?.hasBankReference);
            formik.setFieldValue('recaudos.hasJob', formik?.values?.jobReferences?.hasJob);
            formik.setFieldValue('recaudos.hasIncome', formik?.values?.jobReferences?.hasIncome);
            formik.setFieldValue('recaudos.hasBusiness', formik?.values?.jobReferences?.hasBusiness);
            formik.setFieldValue('recaudos.caracteristicaCliente', formik?.values?.cliente?.caracteristicaCliente);
            formik.setFieldValue('recaudos.tipoCliente', formik?.values?.cliente?.tipoCliente);
            formik.setFieldValue('recaudos.tieneRelacion', formik?.values?.fatca?.tieneRelacion);

            if (hasLevelOneAccount) {
                formik.setFieldValue('recaudos.hasLevelOneAccount', 'si');
            } else {
                formik.setFieldValue('recaudos.hasLevelOneAccount', 'no');
            }
        }
    }, [formik?.values])


    // Consult Client Partial Data

    useEffect(() => {
        const email = formik?.values?.cliente?.mail;

        if (shouldGenerateIncomeDeclaration && email) {
            dispatch(clienteDataParcial({ email }));
        }
    }, [
        dispatch,
        formik?.values?.cliente?.mail,
        shouldGenerateIncomeDeclaration,
    ]);


    // Generate Income Declaration PDF

    useEffect(() => {
        const id = consultClientPartialData?.data?.data?.id;

        if (id) {
            handleGetIncomeDeclarationFile(id);
        }
    }, [dispatch, consultClientPartialData?.data?.data?.id]);

    return (
        <>
            {(isLoading || error) &&
                <Loader
                    message={'Generando declaración de ingresos...'}
                    error={error}
                    action={() => dispatch(clienteDataParcial({ email: formik?.values?.cliente?.mail }))}
                />}


            {!isLoading && !error &&
                <>

                    {/* CONSTANCY: DOCUMENT ID */}

                    {formik.values?.cliente?.tipoDocumento !== "P" &&
                        <FileInput
                            formik={formik}
                            fieldName={'recaudos.documentoIdentidad'}
                            label={'Documento de Identidad del Solicitante'}
                            helpText={'Cédula de identidad del solicitante, para las personas naturales venezolanas o extranjeras residentes en el país, es necesario que esté: Vigente y Legible  Libre de Tachaduras o Enmiendas'}
                            isRequired={true}
                        />}

                    {/* CONSTANCY: DOCUMENT ID */}

                    {formik.values?.cliente?.tipoDocumento == "P" &&
                        <FileInput
                            formik={formik}
                            fieldName={'recaudos.documentoPasaporte'}
                            label={'Pasaporte del Solicitante'}
                            helpText={'Pasaporte para las personas naturales extranjeras no residentes en el país, es necesario que esté:   Vigente y Legible  Libre de Tachaduras o Enmiendas'}
                            isRequired={true}
                        />}


                    {formik.values?.recaudos.hasLevelOneAccount === 'no' &&
                        <>

                            {/* CONSTANCY: RESIDENCY */}

                            <FileInput
                                formik={formik}
                                fieldName={'recaudos.constanciaResidenciaRif'}
                                label={'Registro Único de Información Fiscal (RIF), constancia de residencia o recibo de servicio.'}
                                helpText={'Registro Único de Información Fiscal (RIF) vigente. En caso que la dirección aportada por el cliente no coincida con la registrada en este documento, deberá presentar cualquiera de los siguientes recaudos opcionales: Constancia de residencia emitida por la autoridad civil correspondiente u Original y fotocopia legible de un recibo de servicio público o privado: luz, agua, teléfono, gas, televisión por cable, con antigüedad no mayor a tres (3) meses, donde se evidencie la dirección dada.'}
                                isRequired={true}
                            />

                            {/* CONSTANCY: JOB */}

                            {formik.values?.jobReferences?.hasJob === "si" &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaEmpleo'}
                                    label={'Constancia de Trabajo'}
                                    isRequired={true}
                                    helpText={
                                        <span>Constancia de trabajo (cuando se declare dependencia laboral) con vigencia no mayor a 30 días y debe presentar:
                                            *Membrete y RIF de la empresa<br />
                                            * Dirección y teléfonos locales de la empresa<br />
                                            * Contar con la firma y sello de la empresa<br />
                                            En caso de que la Constancia estuviere expresado en divisas ($/€), deberá calcularse su conversión en base a la tasa oficial establecida por el BCV para el día.</span>
                                    }
                                />}

                            {/* CONSTANCY: INCOME */}

                            {(
                                ['1', '2'].includes(formik.values?.cliente?.tipoCliente) &&
                                (
                                    formik.values?.jobReferences?.hasIncome === "si" ||
                                    formik.values?.jobReferences?.hasBusiness === "si"
                                )
                            ) && (
                                    <FileInput
                                        formik={formik}
                                        fieldName={'recaudos.constanciaIngreso'}
                                        label={'Informe de Aseguramiento de Ingresos.'}
                                        isRequired={true}
                                        helpText={'Informe de Atestiguamiento o revisión sobre ingresos (solo para persona de libre ejercicio) no mayor a tres (3) meses. En caso de que el Informe estuviese expresado en divisas ($/€), deberá calcularse su conversión en base a la tasa oficial establecida por el BCV para el día.'}
                                    />
                                )}

                            {/* CONSTANCY: TRIBUNAL ORDER */}

                            {formik.values?.movilizacionProductos?.motivoApertura == "18" &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaOrdenTribunal'}
                                    label={'Orden del Tribunal'}
                                    isRequired={true}
                                    helpText={'En caso de apertura ordenada por los Tribunales de la República, debe presentar Original y fotocopia del oficio mediante el cual se gira la instrucción'}
                                />}


                            {/* CONSTANCY: OPERATE IN MARKET */}

                            {['6'].includes(formik.values?.cliente?.caracteristicaCliente) &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaAutorizacionOperarMercado'}
                                    label={'Autorización para operar en el mercado'}
                                    isRequired={true}
                                    helpText={'Autorización para operar en el mercado emitida por el Ente Regulador'}
                                />}

                            {/* CONSTANCY: JOB CREDENTIAL */}

                            {['5'].includes(formik.values?.cliente?.caracteristicaCliente) &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaCarnetLaboral'}
                                    label={'Carnet Laboral o Credencial'}
                                    isRequired={true}
                                    helpText={'Carnet Laboral o Credencial'}
                                />}

                            {/* CONSTANCY: LEGAL REPRESENTATIVE */}

                            {['4'].includes(formik.values?.cliente?.caracteristicaCliente) &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaCedulaRepresentanteLegal'}
                                    label={'Cédula de Identidad del Representante Legal'}
                                    isRequired={true}
                                    helpText={
                                        <span>
                                            Cédula de Identidad vigente laminada del Representante Legal, es necesario que esté:<br />
                                            * Vigente y Legible<br />
                                            * Libre de Tachaduras o Enmiendas
                                        </span>
                                    }
                                />}

                            {/* CONSTANCY: LEGAL DESIGNATION */}

                            {['4'].includes(formik.values?.cliente?.caracteristicaCliente) &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaDesignacionLegalComoRepresentante'}
                                    label={'Designación Legal como Representante'}
                                    isRequired={true}
                                    helpText={'Designación Legal como Representante, emitida por un tribunal, para los casos en que el representante del menor de edad, no sea ninguno de los padres.'}
                                />}


                            {/* CONSTANCY: FACTA COMPLEMENT */}

                            {formik.values?.fatca?.tieneRelacion === 'si' &&
                                <FileInput
                                    formik={formik}
                                    fieldName={'recaudos.constanciaComplementoFatca'}
                                    label={'Complemento FATCA (W8, WBEN o W9)'}
                                    isRequired={true}
                                    helpText={'Documento de el complemento FATCA tipo W8, WBEN o W9'}
                                />}


                            {/* CONSTANCY: INCOME DECLARATION */}

                            {shouldGenerateIncomeDeclaration &&
                                <>
                                    <SectionHeading text={'Comprobante de Declaración Jurada de Ingresos'} isSubHeading />

                                    <p>Por favor descargue y firme el PDF de su declaración jurada de ingreso y luego anexe el documento firmado en el campo para Declaración Jurada de Ingresos que está debajo.</p>

                                    {incomeDeclarationFile &&
                                        <DownloadDocumentButton
                                            label={"Decargar Declaracion Jurada de Ingresos"}
                                            fileName={"declaracion-jurada-de-ingresos"}
                                            fileUrl={incomeDeclarationFile}
                                        />}

                                    <FileInput
                                        formik={formik}
                                        fieldName={'recaudos.constanciaDeclaracionJuradaDeIngresos'}
                                        label={'Declaración Jurada de Ingresos'}
                                        isRequired={true}
                                        helpText={'Declaración Jurada de Ingresos'}
                                    />
                                </>}
                        </>}

                    <div className='form-actions'>
                        <Button
                            action={() => dispatch(setFormStep(formStep - 1))}
                            label={'Regresa'}
                            secondaryStyle={true}
                        />

                        <Button
                            type="submit"
                            action={formik.handleSubmit}
                            label={'Continua'}
                        />

                    </div>

                </>}

        </>

    )
}
